// Lib Imports
// import {format} from 'date-fns'
class Note {
  constructor(data) {
    this.pk = data.pk;
    this.note = data.note;
    this.name = data.added_by.first_name + ' ' + data.added_by.last_name;
    this.date = data.created_at;
    this.type = data.note_type;
    this.extraData = data.extra_data;
  }
}
export default Note;